import React from 'react';
import { AnimatedLoader, Bubble } from './styles';

interface Props {
  className?: string;
}

const Loader = ({ className }: Props) => (
  <AnimatedLoader className={className} data-testid="loader">
    <Bubble className="bounce-1" />
    <Bubble className="bounce-2" />
    <Bubble className="bounce-3" />
  </AnimatedLoader>
);

export default Loader;
